import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SubmitCustomerOrder(orderId) {
  const response = await $.soap({
    body: {
      SubmitCustomerOrder: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderId: orderId
      }
    },
    blueprint: {
      submittedId: '$..ID'
    }
  });

  cleanUpResponse(response);
  return response.submittedId;
}